"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EyeClosed = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EyeClosed = function EyeClosed(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.112 6.313a8.898 8.898 0 01-1.364 1.717l1.042 1.242a.6.6 0 01-.92.771l-1.039-1.238a8.259 8.259 0 01-1.419.838l.651 1.789a.6.6 0 11-1.127.41l-.647-1.775a8.08 8.08 0 01-1.689.31V12.2a.6.6 0 01-1.2 0v-1.824a8.079 8.079 0 01-1.69-.31l-.646 1.776a.6.6 0 11-1.127-.41l.65-1.789a8.256 8.256 0 01-1.418-.838l-1.04 1.238a.599.599 0 01-.845.075.6.6 0 01-.075-.846L2.252 8.03A8.885 8.885 0 01.888 6.313a.6.6 0 011.024-.626C3.258 7.887 5.534 9.2 8 9.2s4.742-1.313 6.088-3.513a.6.6 0 011.024.626z",
    fill: "currentColor"
  }));
};

exports.EyeClosed = EyeClosed;
var _default = EyeClosed;
exports.default = _default;